import { Badge, Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const TypeCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return <Badge>{rowData.type}</Badge>;
};

const TypeColumn = () => ({
    accessorKey: 'type',
    header: 'Type',
    size: 2,
    Cell: ({ cell }) => <TypeCell cell={cell} />,
});
export default TypeColumn;
